module.exports = __webpack_public_path__ + "static/Remorhaz-a723915fd218352a1ad166122454a2ef.jpg";